<template>
    <div class="newsdetail">
        <div class="detailbody" v-html="detail.newsdetail"></div>
    </div>
</template>

<script>
import "./detail.less"
export default {
    components: {

    },
    data() {
        return {
            newsid: 1,
            detail: ''
        }
    },
    mounted() {
        this.newsid = this.$route.params.news_id;
        console.log(this.newsid,'this.$route.params.newsid');
        this.$nextTick(() => {
            this.getnewsdetail();
            
        });
    },
    methods: {  
        getnewsdetail() { 
            this.$api.common.newsDetail({id: this.newsid}).then((res) => { 
                this.detail = res.data
            })
        },
    }    
}
</script>
